import type { ReactNode } from 'react';

import styles from './Badge.module.scss';

export type BadgeVariant = 'neutral' | 'success' | 'warning' | 'danger' | 'info' | 'accent';

type BadgeProps = {
  readonly variant?: BadgeVariant;
  readonly size?: 'sm' | 'md';
  readonly dot?: boolean;
  readonly className?: string;
  readonly children: ReactNode;
};

export function Badge({
  variant = 'neutral',
  size = 'md',
  dot = false,
  className,
  children,
}: BadgeProps) {
  const classes = [
    styles.badge,
    styles[variant],
    size === 'sm' ? styles.sm : '',
    className ?? '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <span className={classes}>
      {dot ? <span className={styles.dot} /> : null}
      {children}
    </span>
  );
}
